import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { LoanappService } from './../../services/loanapp.service';

@Component({
  selector: 'app-borrwer-wise-data',
  templateUrl: './borrwer-wise-data.component.html',
  styleUrls: ['./borrwer-wise-data.component.css'],
})
export class BorrwerWiseDataComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  toDate: any;
  fromDate: any;
  loanAppsLoaded: Boolean = false;

  constructor(
    private lservice: LoanappService,
    private router: Router,
    private auth: AuthService
  ) { }

  ngOnInit() {
    let obj = {
      fromDate: this.fromDate,
      toDate: this.toDate,
      limit: 0,
    };
    this.loanAppsLoaded = false;

    this.lservice.getBorrowerWiseData(obj).subscribe((data) => {
      this.loanAppsLoaded = true;

      this.dataRec = true;
      console.log(data);
      if (data['success']) {
        this.lApplications = data['data'];
        this.dataToShow = data['data'];
        for (let i = 0; i < this.dataToShow.length; i++) {
          this.dataToShow[i]['tprice'] =
            this.dataToShow[i]['depositApp']['depositQty'] *
            this.dataToShow[i]['depositApp']['perUnitValue'];
          if (
            !this.isInArray(
              this.lApplications[i]['warehouseName'],
              this.filterWnameArr
            )
          ) {
            this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
          }
        }
      }
    });
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }
  onSearchChange(val) { }
  onChangeWname(val) { }
  onChangeStatus(val) { }
  downloadCSV() { }
  downloadPDF() { }
  print() { }
}
